export default __webpack_public_path__ + "static/media/fixed-asset.1c576984.png";